import * as service from './service'
export default {
  namespace: 'equipmentMallMallList',
  state: {
    demoData: {}
  },
  effects: {
    * querySaleList ({ payload }, { call, put }) {
      const res = yield call(service.querySaleList, payload)
      yield put({
        type: 'save',
        payload: {
          saleList: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
